export async function getAllDirectoryFiles(items: DataTransferItemList): Promise<File[]> {
  const allFiles: File[] = [];
  const entries = extractFileSystemEntries(items);
  console.log(entries)
  await processEntries(entries, allFiles);

  return allFiles
}

function extractFileSystemEntries(items: DataTransferItemList): FileSystemEntry[] {
  const entries: FileSystemEntry[] = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    if (item.kind === 'file') {
      const entry = item.webkitGetAsEntry();
      if (entry) {
        entries.push(entry);
      }
    }
  }

  return entries;
}

async function processEntries(entries: FileSystemEntry[], allFiles: File[]): Promise<void> {
  const promises = entries.map(entry => {
    if (entry.isFile) {
      return processFileEntry(entry as FileSystemFileEntry, allFiles);
    } else if (entry.isDirectory) {
      return processDirectoryEntry(entry as FileSystemDirectoryEntry, allFiles);
    }
    return;
  });
  await Promise.all(promises);
}

async function processFileEntry(fileEntry: FileSystemFileEntry, allFiles: File[]): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    fileEntry.file(
      (file: File) => {
        Object.defineProperty(file, 'webkitRelativePath', {
          value: fileEntry.fullPath,
        });
        allFiles.push(file);
        resolve();
      },
      (error) => reject(error)
    );
  });
}

async function processDirectoryEntry(dirEntry: FileSystemDirectoryEntry, allFiles: File[]): Promise<void> {
  const entries = await readDirectoryEntries(dirEntry);
  await processEntries(entries, allFiles);
}

async function readDirectoryEntries(dirEntry: FileSystemDirectoryEntry): Promise<FileSystemEntry[]> {
  return new Promise<FileSystemEntry[]>((resolve, reject) => {
    const dirReader = dirEntry.createReader();
    const allEntries: FileSystemEntry[] = [];

    const readBatch = () => {
      dirReader.readEntries(
        (entries) => {
          if (entries.length === 0) {
            resolve(allEntries);
          } else {
            allEntries.push(...entries);
            readBatch(); // Continue reading if there are more entries
          }
        },
        (error) => reject(error)
      );
    };

    readBatch();
  });
}
